import { Component, Input, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ErrorService } from '../../services/error.service';
import { find } from 'lodash';
import { debounce } from 'rxjs/operators';
import { timer } from 'rxjs';
import { ReturnStatement } from '@angular/compiler';

@Component({
  selector: 'mob-error-viewer',
  templateUrl: './error-viewer.component.html',
  styleUrls: ['./error-viewer.component.scss']
})
export class ErrorViewerComponent {

  isOpen: boolean = false;
  public form: UntypedFormGroup;
  public result = [];
  public loading:boolean = false;

  constructor(public errorService: ErrorService) {

    this.form = !this.form ? new UntypedFormGroup({
      search: new UntypedFormControl('')
    }) : this.form;


    this.form.valueChanges.pipe(
      debounce(() => timer(600))
    ).subscribe(value => {

      this.loading = true;

      if(value.search){

        this.result = this.errorService.items.filter(e => { 
          const text =JSON.stringify(e); 
          return text.indexOf(value.search.toLowerCase()) > -1;
       });
        
      }
      else{
        this.result = this.errorService.items;
      }
        this.loading = false;

    });
  }


}
